import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import { TranslateOverlay } from "@/components/TranslateOverlay";
import Translations from "@/pages/Translations";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import NouveauDevis from "@/pages/NouveauDevis";
import Navbar from "@/components/Navbar";
import { ActAsScope } from "@/components/ActAs";
import { SimulationBanner } from "@/components/SimulationBanner";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import ModelConfigurator from "@/pages/ModelConfigurator";
import ClientStep from "@/pages/ClientStep";
import ModelSelection from "@/pages/ModelSelection";
import ModelPicker from "@/pages/ModelPicker";
import ModelVersions from "@/pages/ModelVersions";
import ExpoManager from "@/pages/ExpoManager";
import QuoteHistory from "@/pages/QuoteHistory";
import AdvOrders from "@/pages/AdvOrders";
import PriceList from "@/pages/PriceList";
import AdminDashboard from "@/pages/AdminDashboard";
import RemoteSign from "@/pages/RemoteSign";
import TradeIns from "@/pages/TradeIns";
import SalonStats from "@/pages/SalonStats";
import Clients from "@/pages/Clients";
import { ConnectionBanner } from "@/components/ConnectionBanner";

function Shell({ children }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <SimulationBanner />
      <ConnectionBanner />
      {children}
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reinitialiser-mot-de-passe" element={<ResetPassword />} />
            <Route path="/signer/:token" element={<RemoteSign />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Shell><ActAsScope><ClientStep /></ActAsScope></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/selection"
              element={
                <ProtectedRoute>
                  <Shell><ActAsScope><ModelSelection /></ActAsScope></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/modeles"
              element={
                <ProtectedRoute>
                  <Shell><ActAsScope><ModelPicker /></ActAsScope></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/clients"
              element={
                <ProtectedRoute>
                  <Shell><Clients /></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/statistiques"
              element={
                <ProtectedRoute managerOnly>
                  <Shell><SalonStats /></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reprises"
              element={
                <ProtectedRoute>
                  <Shell><TradeIns /></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/expos"
              element={
                <ProtectedRoute>
                  <Shell><ExpoManager /></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/versions"
              element={
                <ProtectedRoute>
                  <Shell><ActAsScope><ModelVersions /></ActAsScope></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurer"
              element={
                <ProtectedRoute>
                  <Shell><ActAsScope><ModelConfigurator /></ActAsScope></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/nouveau-devis"
              element={
                <ProtectedRoute>
                  <Shell><NouveauDevis /></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/devis"
              element={
                <ProtectedRoute>
                  <Shell><QuoteHistory /></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/adv"
              element={
                <ProtectedRoute>
                  <Shell><AdvOrders /></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/tarifs"
              element={
                <ProtectedRoute>
                  <Shell><PriceList /></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute adminOnly>
                  <Shell><AdminDashboard /></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/traductions"
              element={
                <ProtectedRoute>
                  <Shell><Translations /></Shell>
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-right" richColors />
          <TranslateOverlay />
        </BrowserRouter>
        </I18nProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
